/**
 * Configuração de Rotas e Deep Links da Aplicação
 */

export const ROUTES = {
  LANDING: "/",
  HUB: "/hub",
  HUB_ALIAS: "/hub",
  JOGO: "/jogo",
  RACHA: "/racha",
  QUADRAS: "/quadras",
  ARENA_DETAILS: "/arena/:arenaId",
  ARENA_QUADRAS: "/arena/quadras",
  DAYUSE: "/dayuse",
  ARENA_DAYUSE: "/arena/dayuse",
  HORARIOS_EVENTOS: "/horarios-eventos",
  ARENA_HORARIOS_EVENTOS: "/arena/horarios-eventos",
  MENSALISTAS: "/mensalistas",
  ARENA_MENSALISTAS: "/arena/mensalistas",
  HORARIO_FIXO: "/horario-fixo",
  ARENA_HORARIO_FIXO: "/arena/horario-fixo",
  FINANCEIRO: "/financeiro",
  ARENA_FINANCEIRO: "/arena/financeiro",
  ARENA_TORNEIOS: "/arena/torneios",
  TORNEIOS: "/torneios",
  TORNEIO_DETAILS: "/torneio/:tournamentId",
  INSCRICAO_DETAILS: "/inscricao/:tournamentId",
  ASSISTANT_AREA: "/assistant/:tournamentId",
  AJUDANTE_AREA: "/ajudante/:tournamentId",
  PORTAL: "/portal",
  PERFIL: "/perfil",
  DUPLAS: "/duplas",
  STATS: "/stats",
  HISTORICO: "/historico",
  VENDAS: "/vendas",
  ARENA_DASHBOARD: "/arena/dashboard",
  ARENA_VENDAS: "/arena/vendas",
  MEUS_AGENDAMENTOS: "/meus_agendamentos",
  AGENDAMENTOS: "/agendamentos",
  ADMIN: "/admin",
  ADMIN_SUBTAB: "/admin/:subtab",
} as const;

export function getArenaUrl(arenaId: string) {
  return `/arena/${encodeURIComponent(arenaId)}`;
}

export function getTournamentUrl(tournamentId: string) {
  return `/torneio/${encodeURIComponent(tournamentId)}`;
}

export function getInscricaoUrl(tournamentId: string) {
  return `/inscricao/${encodeURIComponent(tournamentId)}`;
}

export function getAssistantAreaUrl(tournamentId: string) {
  return `/assistant/${encodeURIComponent(tournamentId)}`;
}

export function getAdminSubtabUrl(subtab: string) {
  return `/admin/${encodeURIComponent(subtab)}`;
}

/**
 * Mapeia abas legadas do sistema para URLs canônicas
 */
export function tabToRoute(tab: string, subtab?: string): string {
  switch (tab) {
    case "landing":
    case "home":
      return ROUTES.LANDING;
    case "hub":
      return ROUTES.HUB;
    case "jogo":
      return ROUTES.JOGO;
    case "racha":
      return ROUTES.RACHA;
    case "quadras":
      return ROUTES.QUADRAS;
    case "dayuse":
    case "horarios-eventos":
    case "horarios_eventos":
      return ROUTES.ARENA_HORARIOS_EVENTOS;
    case "mensalistas":
      return ROUTES.ARENA_MENSALISTAS;
    case "financeiro":
      return ROUTES.ARENA_FINANCEIRO;
    case "torneios":
      return ROUTES.TORNEIOS;
    case "portal":
      return ROUTES.PORTAL;
    case "perfil":
      return ROUTES.PERFIL;
    case "duplas":
      return ROUTES.JOGO;
    case "stats":
      return ROUTES.STATS;
    case "historico":
      return ROUTES.HISTORICO;
    case "vendas":
      return ROUTES.ARENA_VENDAS;
    case "meus_agendamentos":
    case "agendamentos":
      return ROUTES.MEUS_AGENDAMENTOS;
    case "admin":
      return subtab ? `/admin/${subtab}` : ROUTES.ADMIN;
    default:
      if (tab.startsWith("/")) return tab;
      return "/";
  }
}

/**
 * Mapeia caminho da URL para a aba ativa no estado do app
 */
export function routeToTab(pathname: string): { tab: string; subtab?: string } {
  const p = pathname.toLowerCase();
  if (p === "/" || p === "") return { tab: "landing" };
  if (p === "/hub") return { tab: "hub" };
  if (p.startsWith("/jogo")) return { tab: "jogo" };
  if (p.startsWith("/racha")) return { tab: "racha" };
  if (
    p.startsWith("/horarios-eventos") ||
    p.startsWith("/arena/horarios-eventos") ||
    p.startsWith("/dayuse") ||
    p.startsWith("/arena/dayuse")
  ) {
    return { tab: "dayuse" };
  }
  if (
    p.startsWith("/horario-fixo") ||
    p.startsWith("/arena/horario-fixo") ||
    p.startsWith("/mensalistas") ||
    p.startsWith("/arena/mensalistas")
  ) {
    return { tab: "mensalistas" };
  }
  if (p.startsWith("/financeiro") || p.startsWith("/arena/financeiro")) return { tab: "financeiro" };
  if (p.startsWith("/arena/torneios")) return { tab: "torneios" };
  if (p.startsWith("/arena/vendas") || p.startsWith("/arena/dashboard") || p.startsWith("/vendas")) {
    return { tab: "vendas" };
  }
  if (p.startsWith("/quadras") || p.startsWith("/arena/quadras") || p.startsWith("/arena/")) return { tab: "quadras" };
  if (p.startsWith("/torneios")) return { tab: "torneios" };
  if (p.startsWith("/torneio/") || p.startsWith("/inscricao/") || p.startsWith("/portal")) return { tab: "portal" };
  if (p.startsWith("/perfil")) return { tab: "perfil" };
  if (p.startsWith("/duplas")) return { tab: "jogo" };
  if (p.startsWith("/stats")) return { tab: "stats" };
  if (p.startsWith("/historico")) return { tab: "historico" };
  if (p.startsWith("/meus_agendamentos") || p.startsWith("/agendamentos")) return { tab: "meus_agendamentos" };
  if (p.startsWith("/admin")) {
    const parts = p.split("/").filter(Boolean);
    const sub = parts[1];
    return { tab: "admin", subtab: sub || undefined };
  }
  return { tab: "hub" };
}
